<opac-user-title
  [title]="'user.challenges.title' | translateByCustomerType: customerType.dbValue"
  [skeleton]="(isLoading$ | async) === true"></opac-user-title>

<ng-container *ngIf="(isLoading$ | async) === false">
  <div *ngIf="emptyChallenges$ | async">
    <opac-no-results [label]="'user.challenges.noActiveRecords' | translate">
      <div class="user-card-section">
        <app-challenges-monthly-card
          (createChallenge)="createGoal(ChallengeType.MONTHLY)"></app-challenges-monthly-card>
        <app-challenges-daily-card (createChallenge)="createGoal(ChallengeType.DAILY)"></app-challenges-daily-card>
      </div>
    </opac-no-results>
  </div>

  <opac-user-section
    *ngIf="(emptyChallenges$ | async) === false"
    [title]="'user.challenges.activeChallenges' | translate">
    <div
      class="user-card-section"
      [class.has-challenge]="(monthlyUserChallenge$ | async) || (dailyUserChallenge$ | async)">
      <app-challenges-monthly-card
        [challenge]="monthlyUserChallenge$ | async"
        (createChallenge)="createGoal(ChallengeType.MONTHLY)"
        (deleteChallenge)="showDeleteChallengeModal(ChallengeType.MONTHLY)"
        (updateChallenge)="updateGoal(ChallengeType.MONTHLY)"></app-challenges-monthly-card>

      <app-challenges-daily-card
        [challenge]="dailyUserChallenge$ | async"
        (createChallenge)="createGoal(ChallengeType.DAILY)"
        (deleteChallenge)="showDeleteChallengeModal(ChallengeType.DAILY)"
        (updateChallenge)="updateGoal(ChallengeType.DAILY)"></app-challenges-daily-card>
    </div>

    <app-challenges-admin-card *ngIf="globalAdminChallenge$ | async as challenge" [challenge]="challenge">
    </app-challenges-admin-card>

    <app-challenges-admin-card *ngIf="assignedAdminChallenge$ | async as challenge" [challenge]="challenge">
    </app-challenges-admin-card>
  </opac-user-section>

  <ng-container *ngIf="historyChallenges$ | async as history">
    <opac-user-section *ngIf="history.items.length > 0" [title]="'user.challenges.challengeRecord' | translate">
      <div class="challenges-history-wrapper">
        <app-challenges-history-card *ngFor="let challenge of history.items" [challenge]="challenge">
        </app-challenges-history-card>
      </div>

      <opac-infinite-scroll
        [disabled]="history.page === history.numPages || (isLoading$ | async)"
        [threshold]="100"
        (load)="loadHistory(history.page + 1)"></opac-infinite-scroll>
    </opac-user-section>
  </ng-container>
</ng-container>

<ng-container *ngIf="(isLoading$ | async) === true">
  <challenges-skeleton></challenges-skeleton>
</ng-container>

<app-monthly-dialog #monthlyDialog> </app-monthly-dialog>
<app-daily-dialog #dailyDialog> </app-daily-dialog>

<opac-confirmation-dialog
  [acceptLabel]="'general.remove'"
  [cancelLabel]="'general.cancel'"
  [open]="deleteChallengeType() !== ChallengeType.NONE"
  [title]="'messages.challenge.title' | translate"
  (accept)="deleteChallenge()"
  (cancel)="deleteChallengeType.set(ChallengeType.NONE)">
  {{ 'messages.challenge.confirmRemove' | translate }}
</opac-confirmation-dialog>
